import React, { useState } from "react";
import * as api from "../lib/api";

const BookFilters = ({ genre, onFilterUpdate }) => {
  const [activeCategory, setActiveCategory] = useState();
  const [activeSeries, setActiveSeries] = useState();

  const filterCategory = "category";
  const filterSeries = "series";

  const onFilterChange = (type, itemKey) => {
    if (type === filterCategory) {
      setActiveCategory(itemKey);
      setActiveSeries();
      onFilterUpdate({ series: undefined, category: itemKey });
    } else {
      setActiveCategory();
      setActiveSeries(itemKey);
      onFilterUpdate({ series: itemKey, category: undefined });
    }
  };

  const renderSeries = () => {
    const filtered = api.getSeriesByGenre(genre);
    const results =
      filtered.length > 0
        ? [{ id: undefined, title: "All" }, ...filtered]
        : undefined;

    if (!results || results.length <= 0) return <></>;

    return (
      <div className="row d-none d-md-block">
        <div className="col">
          <strong>Series</strong>
          <ul className="nav book-items">
            {results.map((item) => (
              <li className="nav-item" key={item.id + item.title}>
                <button
                  type="button"
                  className={
                    activeSeries === item.id ? "nav-link active" : "nav-link"
                  }
                  onClick={() => onFilterChange(filterSeries, item.id)}
                >
                  {item.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderCategories = () => {
    const filtered = api.getCategoriesByGenre(genre);
    const results =
      filtered.length > 0
        ? [{ key: undefined, label: "All" }, ...filtered]
        : undefined;
    if (!results || results.length <= 0) return <></>;

    return (
      <div className="row d-none d-md-block">
        <div className="col">
          <strong>Categories</strong>
          <ul className="nav book-items">
            {results.map((item) => (
              <li className="nav-item" key={item.key + item.label}>
                <button
                  type="button"
                  className={
                    activeCategory === item.key ? "nav-link active" : "nav-link"
                  }
                  onClick={() => onFilterChange(filterCategory, item.key)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderCategories()}
      {renderSeries()}
    </>
  );
};

export default BookFilters;
